import { createTheme, Palette } from "@mui/material/styles";

//We just want to make sure the color options we pick match what the theme expects.
type IPalette = Omit<Palette, "getContrastText" | "augmentColor">;
import { purple } from "@mui/material/colors";

const colorPalette: IPalette = {
  mode: "dark",
  common: {
    black: "#000",
    white: "#fff",
  },
  primary: {
    light: "#9fb1c1",
    main: "#0087C6",
    dark: "#0074aa",
    contrastText: "#ffffff",
  },
  secondary: {
    light: "#ffb74d",
    main: "#ff9800",
    dark: "#e65100",
    contrastText: "#ffffff",
  },
  error: {
    main: "#FF2C55",
    light: "rgb(255, 86, 119)",
    dark: "rgb(178, 30, 59)",
    contrastText: "#fff",
  },
  warning: {
    light: "#ff9800",
    main: "#f57c00",
    dark: "#e27100",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  info: {
    light: "#64b5f6",
    main: "#2196f3",
    dark: "#1976d2",
    contrastText: "#fff",
  },
  success: {
    light: "#81c784",
    main: "#4caf50",
    dark: "#388e3c",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  dev: {
    light: purple[300],
    main: purple[500],
    dark: purple[700],
    contrastText: "rgba(1, 1, 1, 0.87)",
  },
  grey: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161",
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: "#fff",
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
  },
  divider: "#000000",
  background: {
    paper: "#212F41",
    default: "#1A2738",
  },
  action: {
    active: "#fff",
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24,
  },
};

export default colorPalette;
